// @ts-nocheck
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import FieldDefinition, { ChildFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";

/**
 * Returns FieldDefinitions default values
 *
 * @param fieldDefinitions - The set of FieldDefinitions to take the values from
 * @returns - The default values of the given fields
 */
export default (fieldDefinitions: FieldDefinition[] | ChildFieldDefinition[]) => {
    const values: HasFields["fields"] = {};

    for (let index = 0; index < fieldDefinitions.length; index++) {
        const element = fieldDefinitions[index];
        values[element.name] = element.defaultValue;
    }

    return values;
};
